import { PlusIcon } from "@heroicons/react/24/solid"
import Page from "@src/layout/Page";
import { useNavigate } from "react-router";
import './styles/index.style.sass';
import { PageHeader } from "@src/components/PageHeader/PageHeader";
import { ListWorlds } from "@src/components/Worlds/ListWorlds";
import { useQuery } from "@tanstack/react-query";
import { getAllWorlds } from "@src/services/requests/worlds";
import { Loader } from "@react-three/drei";

export const WorldIndex = () => {
    const navigate = useNavigate();
    const actions = [{ icon: <PlusIcon />, fn: () => navigate("/worlds/new"), content: "New World" }]

    const worldsQuery = useQuery({
        queryKey: ['worlds', 'own'],
        queryFn: getAllWorlds
    })

    return <Page>
        <div className="worlds">
            <PageHeader title="Worlds" actions={actions} />
            {worldsQuery.isPending
                ? <Loader />
                : <ListWorlds worlds={worldsQuery.data?.worlds || []} />
            }
        </div>
    </Page>
}
